<template>
  <PageHeader
    :class="{ sensitive: !!editing }"
    :title="editing ? editing.title : 'Agent Pages'"
    :breadcrumbs="editing ? [{ label: 'Admin Console' }, { label: 'Agent Pages', to: { name: 'AdminAgentPages' } }] : [{ label: 'Admin Console' }]"
  />

  <div class="p-4">
    <div v-if="error" class="text-sm text-red-600">{{ error }}</div>

    <template v-else-if="pageId">
      <LoadingIndicator v-if="!editing" message="Loading page..." />
      <PageEditor
        v-else-if="isSpec"
        :key="pageId"
        :page-id="pageId"
        :spec="editing.spec"
        :widgets="editing.widgets || {}"
        :subject="editing.subject_type || ''"
        :subject-id="editing.subject_id"
        :shared="!!editing.shared"
        :stem="editing.stem || ''"
        @saved="backToList"
        @cancel="backToList"
      />
      <div v-else class="text-sm text-gray-600">This page is an HTML document written by the agent. Edit it through the agent.</div>
    </template>

    <PagesAdmin v-else />
  </div>
</template>

<script>
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import LoadingIndicator from '@/components/widgetcomponents/library/LoadingIndicator.vue';
import PageEditor from '@/components/Beta/widgets/PageEditor.vue';
import PagesAdmin from '@/components/Pages/PagesAdmin.vue';

export default {
  name: 'AgentPagesAdmin',
  components: { PageHeader, LoadingIndicator, PageEditor, PagesAdmin },
  data() {
    return { editing: null, error: '' };
  },
  computed: {
    pageId() {
      return Number(this.$route.params.id) || null;
    },
    isSpec() {
      return !!(this.editing && this.editing.spec && (this.editing.spec.placements || []).length);
    },
  },
  watch: {
    pageId: { immediate: true, handler: 'load' },
  },
  methods: {
    async load() {
      this.error = '';
      if (!this.pageId) return;
      this.editing = null;
      try {
        const { data } = await this.$axios.get(`/api/impact_analytics/agent-pages/${this.pageId}/`);
        this.editing = data;
      } catch (e) {
        this.error = e?.response?.status === 404 ? 'No page with that id.' : 'That page could not be loaded.';
      }
    },
    backToList() {
      this.$router.push({ name: 'AdminAgentPages' });
    },
  },
};
</script>
